/**
 * Common Service : Basically used for navigation purpose, Name should be changed
 * @exports Common/Service
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, of, Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ToastrService } from 'ngx-toastr';
import { localStorageConstants } from 'src/app/core/localStorageConstants/localStorageConstants';
import { TranslateService } from '@ngx-translate/core';
import { EnvService } from 'src/app/core/services/env.service';

@Injectable({
  providedIn: 'root'
})

export class CommonService {
  /**
   * Constructor of this class
   */
  public profilePic = new BehaviorSubject('');

  constructor(
    public http: HttpClient,
    public router: Router,
    public toastr: ToastrService,
    public translatorService: TranslateService,
    private envService: EnvService
  ) {}
  /**
   * Get Time Picker value
   * @param Object void
   * @return Object Resultset
   */
  getTimePicker(): Observable<any> {
    return of([
      {value: '00:00 AM'},
      {value: '00:30 AM'},
      {value: '01:00 AM'},
      {value: '01:30 AM'},
      {value: '02:00 AM'},
      {value: '02:30 AM'},
      {value: '03:00 AM'},
      {value: '03:30 AM'},
      {value: '04:00 AM'},
      {value: '04:30 AM'},
      {value: '05:00 AM'},
      {value: '05:30 AM'},
      {value: '06:00 AM'},
      {value: '06:30 AM'},
      {value: '07:00 AM'},
      {value: '07:30 AM'},
      {value: '08:00 AM'},
      {value: '08:30 AM'},
      {value: '09:00 AM'},
      {value: '09:30 AM'},
      {value: '10:00 AM'},
      {value: '10:30 AM'},
      {value: '11:00 AM'},
      {value: '11:30 AM'},
      {value: '12:00 PM'},
      {value: '12:30 PM'},
      {value: '01:00 PM'},
      {value: '01:30 PM'},
      {value: '02:00 PM'},
      {value: '02:30 PM'},
      {value: '03:00 PM'},
      {value: '03:30 PM'},
      {value: '04:00 PM'},
      {value: '04:30 PM'},
      {value: '05:00 PM'},
      {value: '05:30 PM'},
      {value: '06:00 PM'},
      {value: '06:30 PM'},
      {value: '07:00 PM'},
      {value: '07:30 PM'},
      {value: '08:00 PM'},
      {value: '08:30 PM'},
      {value: '09:00 PM'},
      {value: '09:30 PM'},
      {value: '10:00 PM'},
      {value: '10:30 PM'},
      {value: '11:00 PM'},
      {value: '11:30 PM'}
    ]);
  }
  /**
   * Get Time Zone value
   * @param Object void
   * @return Object Resultset
   */
  getTimeZone(): Observable<any> {
    return of([
      {value: 'HST', title: 'Hawaii Standard Time'},
      {value: 'AKDT', title: 'Alaska Daylight Time'},
      {value: 'PDT', title: 'Pacific Daylight Time'},
      {value: 'MST', title: 'Mountain Standard Time'},
      {value: 'MDT', title: 'Mountain Daylight Time'},
      {value: 'CDT', title: 'Central Daylight Time'},
      {value: 'EDT', title: 'Eastern Daylight Time'}
    ]);
  }

  setProfilePic(profilePic) {
    this.profilePic.next(profilePic);
  }
  private clearAssessment = new Subject<void>();
  clearUnsavedData$ = this.clearAssessment.asObservable();
  triggerClearAssessment() {
    this.clearAssessment.next();
  }
  fileSizeValidation(file){
    const maxSize = localStorage.getItem('assessmentFileMaxSize') ? parseInt(localStorage.getItem('assessmentFileMaxSize')) : 20;
    const maxSizeInBytes = maxSize * 1024 * 1024;
    if (file.size > maxSizeInBytes) {
      let toastText = '';
      this.translatorService.get(localStorageConstants.fileSizeValidationMessage).subscribe(translatedText => {
        toastText = translatedText;
      });
      this.toastr.error(toastText + ` ${maxSize} MB.`, '', { positionClass: 'toast-bottom-right' });
      return false;
    } else {
      return true;
    }
  }
  safeRedirect(url: string): void {
    if (!url) {
      window.location.href = '/';
      return;
    }
    // Allow relative paths (e.g. '/dashboard') but reject protocol-relative URLs ('//')
    if (url.startsWith('/') && !url.startsWith('//')) {
      window.location.href = url;
      return;
    }
    // Only permit http: and https: — reject javascript:, data:, vbscript:, etc.
    const ALLOWED_PROTOCOLS = ['https:', 'http:'];
    try {
      const redirectUrl = new URL(url);
      if (!ALLOWED_PROTOCOLS.includes(redirectUrl.protocol)) {
        window.location.href = '/';
        return;
      }
      // Allow same-origin redirects — use the browser-normalised href
      if (redirectUrl.origin === window.location.origin) {
        window.location.href = redirectUrl.href;
        return;
      }
      // Check if redirect URL matches any allowed environment URL domains
      if (this.isAllowedEnvironmentUrl(redirectUrl)) {
        window.location.href = redirectUrl.href;
      } else {
        window.location.href = '/';
      }
    } catch (e) {
      window.location.href = '/';
    }
  }

  /**
   * Check if URL is allowed based on environment configuration
   * @param url URL to check
   * @returns boolean indicating if URL is allowed
   */
  private isAllowedEnvironmentUrl(redirectUrl: URL): boolean {
    try {
      const ALLOWED_PROTOCOLS = ['https:', 'http:'];
      if (!ALLOWED_PROTOCOLS.includes(redirectUrl.protocol)) {
        return false;
      }
      // Get all environment URLs
      const envUrls = [
        this.envService.apiUrl, this.envService.redirectUri, this.envService.issuer,
        this.envService.tokenEndpoint, this.envService.loginUrl, this.envService.logoutUrl,
        this.envService.signInURL, this.envService.signInURLSSO, this.envService.adb2cTenantUrl,
        this.envService.magicLink, this.envService.authEndpoint, this.envService.magicLinkScope,
        this.envService.oktaIssuer, this.envService.oktaRedirectUri
      ].filter(envUrl => envUrl && typeof envUrl === 'string');
      // Check if redirect URL has same origin as any environment URL
      return envUrls.some(envUrl => {
        try {
          const envUrlObj = new URL(envUrl);
          // Ensure trailing slash to prevent partial-hostname bypass (e.g. evil.api.example.com)
          const normalizedEnvUrl = envUrl.endsWith('/') ? envUrl : envUrl + '/';
          return redirectUrl.origin === envUrlObj.origin ||
                 redirectUrl.hostname === envUrlObj.hostname ||
                 redirectUrl.href.startsWith(normalizedEnvUrl);
        } catch (e) {
          return false;
        }
      }) || redirectUrl.hostname === 'localhost' || redirectUrl.hostname === '127.0.0.1';

    } catch (e) {
      return false;
    }
  }
}
